module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-3-Social-Static-Ad.09b46f53.png";